const ProviderData = {
    fullName: "Christian Schweigel",
    street: "Hallesche Allee 13",
    zipCodeCity: "71639 Karlsruhe",
    email: "imprint.cschweigel@pm.me",
    phoneNumber: "+4915232007199"
}

export default ProviderData;
